interface IProps {
    color: string;
}

export const UserIcon = ({ color }: IProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="27" viewBox="0 0 23 27" fill="none">
            <path d="M14.95 15.75C14.7782 15.75 14.6064 15.7746 14.4425 15.8266C13.511 16.1227 12.5314 16.3125 11.5 16.3125C10.4686 16.3125 9.48896 16.1227 8.55675 15.8266C8.39288 15.7746 8.22182 15.75 8.05004 15.75C3.58952 15.75 -0.0236024 19.2994 0.000116111 23.6686C0.0101785 25.515 1.56194 27 3.45008 27H19.5499C21.4381 27 22.9898 25.515 22.9999 23.6686C23.0236 19.2994 19.4105 15.75 14.95 15.75ZM11.5 13.5C15.3108 13.5 18.3999 10.478 18.3999 6.75C18.3999 3.02203 15.3108 0 11.5 0C7.68923 0 4.60007 3.02203 4.60007 6.75C4.60007 10.478 7.68923 13.5 11.5 13.5Z" fill={color} />
        </svg>
    )
}